<div class="forgot-password-page">
  <app-header
    [title]="'Mot de passe oublié'"
    [showBackButton]="true"
    [showMenu]="false"
    [usePageBackground]="true"
  ></app-header>

  <div class="page-content">
    @if (isResetMode()) { @if (isResetSubmitted()) {
    <div class="confirmation-container">
      <div class="confirmation-icon">✅</div>
      <h2>Mot de passe modifié !</h2>
      <p class="confirmation-message">
        Ton mot de passe a été changé avec succès.<br />
        Tu peux maintenant te reconnecter.
      </p>
      <button type="button" class="btn-back" (click)="goToLogin()">Retour à la connexion</button>
    </div>
    } @else {
    <div class="intro-section">
      <div class="intro-icon">🔐</div>
      <p class="intro-text">Choisis un nouveau mot de passe sécurisé.</p>
    </div>

    <form [formGroup]="resetForm" (ngSubmit)="resetPassword()" class="password-form">
      <div class="form-group">
        <label for="newPassword">Nouveau mot de passe *</label>
        <div class="password-input-wrapper">
          <input
            [type]="showNewPassword() ? 'text' : 'password'"
            id="newPassword"
            formControlName="newPassword"
            placeholder="Min. 8 caractères"
            [class.invalid]="isFieldInvalid(resetForm, 'newPassword')"
          />
          <button type="button" class="toggle-password" (click)="togglePasswordVisibility('new')">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6z" />
              <circle cx="12" cy="12" r="3" />
              @if (showNewPassword()) {
              <line x1="4" y1="20" x2="20" y2="4" />
              }
            </svg>
          </button>
        </div>
        @if (isFieldInvalid(resetForm, 'newPassword')) {
        <span class="error-text">Le mot de passe doit contenir au moins 8 caractères</span>
        }
      </div>

      <div class="form-group">
        <label for="confirmPassword">Confirmer le mot de passe *</label>
        <div class="password-input-wrapper">
          <input
            [type]="showConfirmPassword() ? 'text' : 'password'"
            id="confirmPassword"
            formControlName="confirmPassword"
            placeholder="Confirme ton mot de passe"
            [class.invalid]="
              isFieldInvalid(resetForm, 'confirmPassword') || resetForm.hasError('passwordMismatch')
            "
          />
          <button
            type="button"
            class="toggle-password"
            (click)="togglePasswordVisibility('confirm')"
            [attr.aria-label]="
              showConfirmPassword() ? 'Masquer le mot de passe' : 'Afficher le mot de passe'
            "
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6z" />
              <circle cx="12" cy="12" r="3" />
              @if (showConfirmPassword()) {
              <line x1="4" y1="20" x2="20" y2="4" />
              }
            </svg>
          </button>
        </div>
        @if (isFieldInvalid(resetForm, 'confirmPassword')) {
        <span class="error-text">La confirmation est requise</span>
        } @if (resetForm.hasError('passwordMismatch') && resetForm.get('confirmPassword')?.touched)
        {
        <span class="error-text">Les mots de passe ne correspondent pas</span>
        }
      </div>

      @if (errorMessage()) {
      <div class="error-banner">{{ errorMessage() }}</div>
      }

      <button type="submit" class="btn-submit" [disabled]="isSubmitting()">
        @if (isSubmitting()) {
        <span class="spinner"></span>
        Modification en cours... } @else { Réinitialiser le mot de passe }
      </button>
    </form>
    } } @else { @if (isEmailSent()) {
    <div class="confirmation-container">
      <div class="confirmation-icon">📩</div>
      <h2>Email envoyé</h2>
      <p class="confirmation-message">
        Si un compte existe avec cet email, tu vas recevoir un lien pour réinitialiser ton mot de
        passe.
      </p>
      <button type="button" class="btn-back" (click)="goToLogin()">Retour à la connexion</button>
    </div>
    } @else {
    <div class="intro-section">
      <div class="intro-icon">✉️</div>
      <p class="intro-text">Entre ton email pour recevoir un lien de réinitialisation.</p>
    </div>

    <form [formGroup]="requestForm" (ngSubmit)="sendResetEmail()" class="password-form">
      <div class="form-group">
        <label for="email">Email *</label>
        <input
          id="email"
          type="email"
          formControlName="email"
          placeholder="votre@email.com"
          [class.invalid]="isFieldInvalid(requestForm, 'email')"
        />
        @if (isFieldInvalid(requestForm, 'email')) {
        <span class="error-text">Merci d'indiquer un email valide</span>
        }
      </div>

      @if (errorMessage()) {
      <div class="error-banner">{{ errorMessage() }}</div>
      }

      <button type="submit" class="btn-submit" [disabled]="isSubmitting()">
        @if (isSubmitting()) {
        <span class="spinner"></span>
        Envoi en cours... } @else { Envoyer le lien }
      </button>
    </form>
    } }
  </div>
</div>
